import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IAppState } from 'shared/common/state';
import {
  trackShowSaveSearchClick,
  trackSuburbanShowSaveSearchClick,
  trackSuburbanCloseSaveSearchClick,
  trackSuburbanSaveSearchSubscribed,
  trackSaveSearchSubscribed,
} from 'shared/containers/FiltersContainer/tracking';
import { IJsonQuery } from 'shared/json_query';
import { selectSource } from 'shared/selectors';
import { getTrackingData } from 'shared/selectors/getTrackingData';
import { ITrackingPageData } from 'shared/serp/state/tracking';

import { isSuburban, offerTypeFromJsonQuery, TJsonQuery } from '../../../../packages/JsonQuery';
import { useSaveSearchContext, TOnSubmitSaveSearchParams } from '../../../../packages/SaveSearchModal';

/**
 * Копипаста логики из SaveSearchButtonContainer без кнопки (кнопка лежит в самом микрофронте фильтров)
 * Открытие модалки происходит через событие микрофронта
 */
export const useSaveSearchModal = () => {
  const { open, onClose, onOpen, subscribeToPush } = useSaveSearchContext();

  const jsonQuery = useSelector<IAppState, IJsonQuery>(state => state.results.jsonQuery);
  const isSuburbanSearch = isSuburban(offerTypeFromJsonQuery(jsonQuery));
  const { page } = useSelector(getTrackingData);

  const source = useSelector(selectSource);

  const onSubscribed = useCallback(
    (params: TOnSubmitSaveSearchParams) => {
      subscribeHandler(isSuburbanSearch, jsonQuery, page, params, source);
    },
    [isSuburbanSearch, jsonQuery, page, source],
  );

  const onModalOpen = useCallback(() => {
    trackShowSaveSearchClick();

    if (isSuburbanSearch) {
      trackSuburbanShowSaveSearchClick(jsonQuery);
    }
  }, [isSuburbanSearch, jsonQuery]);

  const onModalClose = useCallback(() => {
    onClose();

    if (isSuburbanSearch) {
      trackSuburbanCloseSaveSearchClick(jsonQuery);
    }
  }, [isSuburbanSearch, jsonQuery]);

  /**
   * Вот подписка
   * В дальнейшем SaveSearchButton будет вынесена в отдельный микрофронт и дубль логики уйдет
   */
  useEffect(() => {
    addEventListener('saveSearchButton:clicked', onOpen);

    return () => {
      removeEventListener('saveSearchButton:clicked', onOpen);
    };
  }, [onOpen]);

  return { open, onSubscribed, onModalOpen, onModalClose, subscribeToPush };
};

function subscribeHandler(
  isSuburbanSearch: boolean,
  jsonQuery: TJsonQuery,
  page: ITrackingPageData,
  params: TOnSubmitSaveSearchParams,
  source?: string,
) {
  const { defaultEmail, defaultTitle, subscribeToPushAvailable, ...commonParameters } = params;

  if (isSuburbanSearch) {
    trackSuburbanSaveSearchSubscribed({
      ...commonParameters,
      defaultTitle,
      defaultEmail,
      jsonQuery,
      page,
      source,
    });
  }

  trackSaveSearchSubscribed({
    ...commonParameters,
    jsonQuery,
    subscribeToPushAvailable,
  });
}
